import { __decorate, __rest } from "tslib";
/**
 * 待入场车辆
 * */
import React, { Component } from 'react';
import { Table, Button, notification, DatePicker, Form, Row, Col } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, OperateShowMore } from '@/components/index';
import { dispatch } from '@@/store';
import Authorized from '@/components/Auth/auth';
import { dealListValueShow, dealTimeAnotherLine, dealValueShow } from '@/shared/functions';
import luban from '@souche-f2e/luban-js';
import { fontEndConfig, showCarDetail } from '@/shared/utils';
import moment from 'moment';
import recallApprove from '@/pages/ApproveManage/_components/RecallApprove';
import { dealTableScroll } from './function';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
});
// @ts-ignore
let ApproveResultSuccess = class ApproveResultSuccess extends Component {
    constructor(props) {
        super(props);
        // desc 选中表格checkboxs
        this.onSelectedTableItem = (selectedRowKeys, selectedRows) => {
            this.selectedTable(selectedRowKeys, selectedRows, this.props.approve, 'Success');
        };
        // desc 表格跳页
        this.tableUpdate = (page, pageSize) => {
            dispatch.approve.updateTable({
                page,
            });
        };
        // desc 创建场次发拍
        this.session = () => {
            luban.send({
                eventType: 'click',
                typeId: 'PSGJB-CAR-QBSP-QBSPCG-CJCC',
            });
            const idList = this.props.approve.checkedKeySuccess;
            if (idList.length > 0) {
                dispatch.session.createSession({
                    idList,
                    routePath: '/CarManage/CreateSession',
                });
            }
            else {
                notification.warn({
                    message: '请至少选择一辆车再创建场次',
                });
            }
        };
        this.state = {
            clipped: [
                { dataIndex: 'carModelName' },
                { dataIndex: 'vin' },
                { dataIndex: 'license' },
                { dataIndex: 'locationName' },
                { dataIndex: 'buyPriceYuan' },
                { dataIndex: 'basePriceYuan' },
                { dataIndex: 'auctionPriceYuan' },
            ],
            colums: [
                {
                    title: '车辆信息',
                    dataIndex: 'carMsg',
                    fixed: 'left',
                    width: 400,
                    render: (data, record) => {
                        const { reportType, goodsId, carModelName, firstImage, vin, license, locationName, rankDesc, rankLevel } = record;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={carModelName}/>
                </div>
                <div>
                  <div>
                    <a onClick={() => {
                            showCarDetail(goodsId);
                        }}>
                      {carModelName}
                    </a>
                  </div>
                  <div>{`VIN码：${dealValueShow(vin)}`}</div>
                  <div>
                    {reportType === 1 && (<img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>)}
                    <div className={'tag_item'}>{license}</div>
                    <div className={'tag_item'}>{locationName}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '卖家经销商',
                    dataIndex: 'sellerName',
                    width: 150,
                    render: (sellerName, record, index) => {
                        const lubanID = 'PSGJB-CAR-QBSP-QBSPCG-MFJXS';
                        return sellerName !== fontEndConfig.noValueReplace ? (<a luban-id={lubanID} onClick={() => {
                            sellerName && showInfo('seller', record.sellerCode);
                        }}>
                {sellerName}
              </a>) : sellerName;
                    },
                },
                {
                    title: '价格信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'priceMsg',
                    width: 200,
                    render(data, record) {
                        const { basePriceYuan, auctionPriceYuan } = record;
                        return (<div>
                
                <div>保留价：{basePriceYuan}</div>
                <div>起拍价：{auctionPriceYuan}</div>
              </div>);
                    },
                },
                {
                    title: '通过时间',
                    dataIndex: 'modifyTime',
                    wdith: 150,
                    render: (modifyTime) => {
                        return modifyTime ? (dealTimeAnotherLine(modifyTime)) : fontEndConfig.noValueReplace;
                    },
                },
                {
                    title: '操作',
                    key: 'operate',
                    width: 100,
                    fixed: 'right',
                    render: (record, index) => (<OperateShowMore>
              <Authorized allow={'psgjb-carthrough-withdraw'}>
                <a luban-id={'PSGJB-CAR-QBSP-QBSPCG-CHSP'} onClick={(event) => {
                        recallApprove(record, () => {
                            dispatch.approve.updateTable({ acyiveKey: 'Success' });
                            dispatch.carState.getEveryStateCarNum({});
                        });
                    }}>
                  撤回审批
                </a>
              </Authorized>
            </OperateShowMore>),
                },
            ],
            globalSearch: {},
            privateSearch: {},
        };
        this.onSelectedTableItem = this.onSelectedTableItem.bind(this);
        this.dealCheckedNum = this.dealCheckedNum.bind(this);
        this.selectedTable = this.selectedTable.bind(this);
    }
    componentDidMount() {
        dispatch.carState.getEveryStateCarNum({});
        this.searchData(this.props.search);
    }
    componentWillUnmount() {
        dispatch.approve.resetState({});
    }
    dealCheckedNum(checkedKey) {
        const checked = checkedKey.length;
        // desc 跨页多选
        // Object.keys(checkedKey).forEach((key) => {
        //   checked += checkedKey[key].length;
        // });
        return checked;
    }
    selectedTable(selectedRowKeys, selectedRows, approve, mark) {
        // desc 跨页多选
        // const CheckedKey = approve[`checkedKey${mark}`];
        // const checkedVal = approve[`checkedVal${mark}`];
        // const pageIndex = approve[`pageIndex${mark}`];
        // CheckedKey[`index_${pageIndex}`] = selectedRowKeys;
        // checkedVal[`index_${pageIndex}`] = selectedRows;
        const checkedNum = this.dealCheckedNum(selectedRowKeys);
        dispatch.approve.Selected_Table([
            {
                name: `checkedKey${mark}`,
                data: selectedRowKeys,
            },
            {
                name: `checkedVal${mark}`,
                data: selectedRows,
            },
            {
                name: `checkedNum${mark}`,
                data: checkedNum,
            },
        ]);
    }
    search() {
        const { globalSearch, privateSearch } = this.state;
        const params = Object.assign(Object.assign({}, globalSearch), privateSearch);
        dispatch.approve.SET_STATE({
            searchData: params,
        });
        console.log('123');
        dispatch.approve.updateTable({ page: 1, acyiveKey: 'Success' });
    }
    searchData(searchData) {
        const { provinceCode, cityCode } = searchData, otherSearch = __rest(searchData, ["provinceCode", "cityCode"]);
        this.setState({
            globalSearch: Object.assign(Object.assign({}, otherSearch), { localProvinceCode: provinceCode, locationCode: cityCode }),
        }, () => {
            this.search();
        });
    }
    render() {
        const { tableSuccess, pageIndexSuccess, pageSizeSuccess, tableSuccessTotal, checkedKeySuccess, tableKey, loadingSuccess, } = this.props.approve;
        const { colums, globalSearch, privateSearch, clipped } = this.state;
        const { dealColumns, scrollX } = dealTableScroll(colums);
        return (<React.Fragment>
        <TableContainer exportObj={{
            type: 'goods',
            params: Object.assign(Object.assign(Object.assign({}, globalSearch), privateSearch), { exportType: 'audit_passed_goods_data' }),
            fileName: '车辆管理-待入场',
            allow: 'psgjb-carpenddrc-export',
        }}>
          <Row gutter={16} align={'middle'} type={'flex'} justify={'space-between'} style={{
            marginRight: '100px',
        }}>
            <div>
              <Authorized allow={'psgjb-carthrough-foundsession'}>
                <span style={{
            margin: '0 10px',
            color: '#666666',
        }}>
                  已选择 {checkedKeySuccess.length || 0} 项
                </span>
                <Button type="primary" onClick={this.session}>创建场次</Button>
              </Authorized>
            </div>
            <Col span={8}>
              <Form.Item className={'search_time_label_border form_date_width_100'} label={'申请时间'} colon={false}>
                <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            let [startTime, endTime] = dates;
            startTime && (startTime = startTime.format('YYYY-MM-DD'));
            endTime && (endTime = endTime.format('YYYY-MM-DD'));
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { startTime,
                    endTime }),
            }, () => {
                this.search();
            });
        }}/>
              </Form.Item>
            </Col>
          </Row>
          <Table className={'draw_table_all_border draw_table_checkbox scroll_table'} loading={loadingSuccess} rowKey={tableKey} scroll={{
            x: scrollX,
        }} columns={dealColumns} dataSource={dealListValueShow({
            gistData: clipped,
            data: tableSuccess,
        })} rowSelection={{
            selectedRowKeys: checkedKeySuccess,
            onChange: this.onSelectedTableItem,
        }} pagination={{
            current: pageIndexSuccess,
            defaultPageSize: pageSizeSuccess,
            showQuickJumper: true,
            total: tableSuccessTotal,
            onChange: this.tableUpdate,
            showTotal: total => `共${total}条`,
        }}/>
        </TableContainer>
      </React.Fragment>);
    }
};
ApproveResultSuccess = __decorate([
    connect(mapStateToProps, null, null, { forwardRef: true })
], ApproveResultSuccess);
export default ApproveResultSuccess;
